import { Controller } from "@hotwired/stimulus";

const FUNCTION_MAPPER = {
  string: [
    { value: "_eq", displayValue: "=" },
    { value: "_not_eq", displayValue: "!=" },
  ],
  text: [
    { value: "_eq", displayValue: "=" },
    { value: "_not_eq", displayValue: "!=" },
  ],
  integer: [
    { value: "_eq", displayValue: "=" },
    { value: "_not_eq", displayValue: "!=" },
    { value: "_lt", displayValue: "<" },
    { value: "_gt", displayValue: ">" },
    { value: "_lteq", displayValue: "<=" },
    { value: "_gteq", displayValue: ">=" },
  ],
  decimal: [
    { value: "_eq", displayValue: "=" },
    { value: "_not_eq", displayValue: "!=" },
    { value: "_lt", displayValue: "<" },
    { value: "_gt", displayValue: ">" },
    { value: "_lteq", displayValue: "<=" },
    { value: "_gteq", displayValue: ">=" },
    { value: "_blank", displayValue: "is blank" },
  ],
  float: [
    { value: "_eq", displayValue: "=" },
    { value: "_not_eq", displayValue: "!=" },
    { value: "_lt", displayValue: "<" },
    { value: "_gt", displayValue: ">" },
    { value: "_lteq", displayValue: "<=" },
    { value: "_gteq", displayValue: ">=" },
  ],
  date: [
    { value: "_eq", displayValue: "=" },
    { value: "_not_eq", displayValue: "!=" },
    { value: "_lt", displayValue: "<" },
    { value: "_gt", displayValue: ">" },
    { value: "_lteq", displayValue: "<=" },
    { value: "_gteq", displayValue: ">=" },
  ],
  datetime: [
    { value: "_eq", displayValue: "=" },
    { value: "_not_eq", displayValue: "!=" },
    { value: "_lt", displayValue: "<" },
    { value: "_gt", displayValue: ">" },
    { value: "_lteq", displayValue: "<=" },
    { value: "_gteq", displayValue: ">=" },
  ],
  boolean: [
    { value: "_true", displayValue: "is true" },
    { value: "_false", displayValue: "is false" },
  ],
  enum: [
    { value: "_eq", displayValue: "=" },
    { value: "_not_eq", displayValue: "!=" },
  ],
};

const INPUT_TYPE_MAPPER = {
  integer: "number",
  decimal: "number",
  float: "number",
  date: "date",
  string: "text",
  text: "text",
  boolean: "boolean",
  enum: "enum",
};
export default class extends Controller {
  static targets = [
    "columnSelect",
    "functionSelect",
    "valueInput",
    "filterList",
  ];

  static outlets = ["view-data-tabulator"];

  static values = {
    data: Object,
    selectValueTranslation: String,
    selectFunctionTranslation: String,
  };

  connect() {
    this.setupColumnSelect();
  }

  columnChanged(event) {
    const selectedColumn = event.target.value;
    const columnType = this.dataValue[selectedColumn]?.type || "";

    // reset function and value
    this.functionSelectTarget.classList.add("hidden");
    this.valueInputTarget.classList.add("hidden");

    // Setup function and value based on column type
    this.setupFunctionSelect(columnType);
    this.setupValueInput(columnType);
  }

  functionChanged() {
    if (this.functionSelectTarget.value === "") {
      this.valueInputTarget.classList.add("hidden");
    } else {
      this.valueInputTarget.classList.remove("hidden");
    }
  }

  createOption(value, textContent) {
    const option = document.createElement("option");
    option.value = value;
    option.textContent = textContent;
    return option;
  }

  setupColumnSelect() {
    console.log(this.dataValue);

    for (const [key, value] of Object.entries(this.dataValue)) {
      const title = value["label"] || key;
      const option = this.createOption(key, title);
      this.columnSelectTarget.appendChild(option);
    }
  }

  setupFunctionSelect(type) {
    this.functionSelectTarget.classList.remove("hidden");

    const typeFunctions = FUNCTION_MAPPER[type] || [];
    this.functionSelectTarget.innerHTML =
      `<option value="">${ this.selectFunctionTranslationValue}</option>`;

    for (const typeFunction of typeFunctions) {
      const option = this.createOption(
        typeFunction.value,
        typeFunction.displayValue
      );
      this.functionSelectTarget.appendChild(option);
    }
  }

  setupValueInput(type) {
    const newType = INPUT_TYPE_MAPPER[type] || "text";
    this.valueInputTarget.innerHTML = "";

    if (newType === "boolean") {
      return;
    }
    if (newType === "enum") {
      this.setupEnumSelect();
      return;
    }

    const input = document.createElement("input");
    input.type = newType;
    input.className = "rounded-md ml-1";

    this.valueInputTarget.appendChild(input);
  }

  setupEnumSelect() {
    const selectedColumn = this.columnSelectTarget.value;

    const select = document.createElement("select");
    select.className = "rounded-md ml-1";

    const defaultOption = this.createOption("", this.selectValueTranslationValue);
    select.appendChild(defaultOption);

    for (const value of this.dataValue[selectedColumn]?.values) {
      const option = this.createOption(value, value);
      select.appendChild(option);
    }

    this.valueInputTarget.appendChild(select);
  }

  addFilter() {
    const filterData = this.getFilterData();

    if (!(filterData.column && filterData.function)) {
      return;
    }

    // tell the table to update the filter
    this.viewDataTabulatorOutlet.table.filter.addFilterNew(filterData);
    const filterText = this.buildFilterText(filterData);
    this.addFilterToList(filterText);
  }

  getFilterData() {
    const input = this.valueInputTarget.querySelector("input");
    const select = this.valueInputTarget.querySelector("select");

    return {
      column: this.columnSelectTarget.value,
      function: this.functionSelectTarget.value,
      inputValue: input ? input.value : "",
      selectValue: select ? select.value : "",
    };
  }

  buildFilterText(filterData) {
    const { column, function: func, inputValue, selectValue } = filterData;
    const value = inputValue || selectValue;
    return `${column}${func}${value ? `: ${value}` : ""}`;
  }

  addFilterToList(filterText) {
    const listItem = document.createElement("li");
    listItem.textContent = filterText;
    this.filterListTarget.appendChild(listItem);
  }

  clearFilters() {
    this.viewDataTabulatorOutlet.table.filter.clearFilters();
    this.filterListTarget.innerHTML = "";
  }
}
